<template>
    <div class="editing-disabled" v-if="!editing">
        <div class="show-value">
            <span v-if="isModelEmpty">{{$t('editable.input.nodata')}}</span>
            <span v-else >{{ modelValue }}</span>
        </div>
        <ButtonBlue class="btn" :text="$t('editable.input.edit')" :on-click="enableEditing"/>
    </div>
    <div v-else class="column">
        <span v-if="mdp && !isMdpLengthValid" class="span-error">{{$t('modale.my.account.contact.password.invalid.length')}}</span>
        <span v-if="mdp && !isMdpValid" class="span-error">{{$t('modale.my.account.contact.password.invalid.caractere')}}</span>
        <div class="row">
            <div class="input-container" :class="{disabled: isSaving}">
                <input
                    class="text-input"
                    :class="{disabled: isSaving}"
                    :type="mdp ? 'password' : 'tel'"
                    v-model="tempValue"
                    required
                    :disabled="isSaving"
                />
            </div>
        <ButtonBlue class="btn" :text="$t('editable.input.save')" :on-click="saveEdit" :disabled="saveButtonDisabled"/>
        <ButtonBlue class="btn" :text="$t('editable.input.cancel')" :on-click="cancelEditing" :disabled="isSaving"/>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ButtonBlue from '@/components/ui-components/ButtonBlue.vue';
import regex from '@/common/utils/Regex';

export default defineComponent({
    emits: ['save'],
    name: 'EditableInput',
    components: {ButtonBlue},
    props: {
        modelValue: {
            type: String,
            required: true,
        },
        isSaving: {
            type: Boolean,
        },
        mdp: {
            type: Boolean,
        },
    },
    data() {
        return {
            tempValue: '',
            editing: false
        };
    },
    methods: {
        enableEditing(){
            if (!this.mdp) {
                this.tempValue = this.modelValue;
            }
            this.editing = true;
        },
        cancelEditing(){
            this.editing = false;
        },
        saveEdit(){
            this.$emit('save', this.tempValue);
        },
    },
    computed: {
        saveButtonDisabled(): boolean{
            return this.tempValue == undefined
                || this.tempValue?.length === 0
                || this.tempValue === this.modelValue
                || this.isSaving
                || (this.mdp && !this.isMdpValid)
                || (this.mdp && !this.isMdpLengthValid);
        },
        isModelEmpty(): boolean{
            return this.modelValue === undefined;
        },
        isMdpLengthValid() : boolean {
            return regex.mdpLongueur().test(this.tempValue);
        },
        isMdpValid() : boolean {
            let nombreConditionValide = 0;
            if(regex.mdpMajuscule().test(this.tempValue)) {
                nombreConditionValide++;
            }
            if(regex.mdpNombre().test(this.tempValue)) {
                nombreConditionValide++;
            }
            if(regex.mdpCaractereSepcial().test(this.tempValue)) {
                nombreConditionValide++;
            }
            if(regex.mdpMinuscule().test(this.tempValue)) {
                nombreConditionValide++;
            }
            return nombreConditionValide >=3;
        },
    },
    watch: {
        isSaving(newState) {
            if (newState === false) {
                this.cancelEditing();
            }
        }
    },
});
</script>

<style scoped>
.editing-disabled {
    display: flex;
}
.show-value {
    align-self: center;
    margin-right: 10px;
    width: 35%;
}
.input-container {
    display: flex;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    align-items: center;
}
.text-input {
    font-family: 'Roboto',serif;
    opacity: 0.87;
    border: none;
    outline: none;
    color: var(--black);
    padding-left: 8px;
}
.btn {
    margin-left: 6px;
    width: 90px;
    border-radius: 5px;
    cursor: pointer;
}
.disabled {
    cursor: not-allowed;
    background: var(--button-color-disabled);
    color : var(--text-color-disabled);
}
.column {
    display: flex;
    flex-direction: column;
}
.row {
    display: flex;
    flex-direction: row;
    min-height: 30px;
}
.span-error {
    color: var(--red);
    font-size: small;
}
</style>
